module.exports = __webpack_public_path__ + "img/DF_cell_illustration_desktop.e43a3f02.jpg";